// extracted by mini-css-extract-plugin
export default {"route":"Item_route__43rDM","routeContent":"Item_routeContent__Ff7bV"};